<div mat-dialog-content>
  <button *ngFor="let lang of data.available" [disabled]="data.selected.includes(lang)"
          [mat-dialog-close]="{lang: lang, type: data.type}"
          [ngClass]="{ 'disabled': data.selected.includes(lang) }" mat-button>
    <div class="image-container">
      <img src="../../../assets/img/languages/{{lang}}.jpg"/>
    </div>
    <div class="name">{{'general.languages.' + lang | translate}}</div>
  </button>
</div>

